import { useQueryDocumentTemplates } from '@/hooks/query/useQueryDocumentTemplates';
import {
  ClarificationAnswerTemplateLabel as ClarificationAnswerTemplateLabelView,
  TemplatePickerList as TemplatePickerListView,
  type TemplatePickerListProps,
} from '@heidi/agents';

/** Binds the template picker to the app's document-templates query. */
export const TemplatePickerList = (props: TemplatePickerListProps): JSX.Element => (
  <TemplatePickerListView {...props} useTemplates={useQueryDocumentTemplates} />
);

/**
 * The Answers-card label for a picked template id, bound to the same query.
 * It stays here so the ``templates/crud`` legacy-importer edge stays on this
 * already-baselined file instead of growing from the timeline presentation layer.
 */
export const ClarificationAnswerTemplateLabel = ({
  templateId,
}: {
  templateId: string;
}): JSX.Element => (
  <ClarificationAnswerTemplateLabelView
    templateId={templateId}
    useTemplates={useQueryDocumentTemplates}
  />
);
